import { useEffect, useState } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { getParsers } from '../../EdiSelfService/api'
import { Parser } from '../../EdiSelfService/types'

export const useGetCurrentParser = (parserId: Maybe<string>) => {
  const [parser, setParser] = useState<Parser>()
  const getCurrentParser = async (parserId: Maybe<string>) => {
    const parsers = await getParsers()
    const currentParser = parsers.filter(parser => parser.id === Number(parserId))
    setParser(currentParser[0])
  }

  useEffect(() => {
    getCurrentParser(parserId)
  }, [parserId])

  return parser
}
